module.exports = __webpack_public_path__ + "static/lakeside-patio-restaurant-in-clemson-sc-9d86a1482bc762961383fc25f2f89d00.jpg";